export const JOB_SET_JOBS = 'JOB_SET_JOBS';
export const JOB_SET_IS_LOADED = 'JOB_SET_IS_LOADED';
